import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { ATTENDEE_CHECK_IN } from '../../../../../helpers'
import { BOOKING } from '../../../../../reduxs'
import { getGuestLabel } from './checkIn'
import { GuestCheckInStatusStyled } from './styles'

const getInitials = (label) => label.trim().split(/\s+/).slice(0, 2).map(part => part.charAt(0)).join('').toUpperCase()

function GuestCheckInStatus(props) {
  const { bookingId, language, username, colorTheme, getBookingCheckIn } = props

  const [detail, setDetail] = useState(null)

  useEffect(() => {
    if (!bookingId) return
    getBookingCheckIn(bookingId).then(res => {
      if (res && res.status) setDetail(res.data)
    })
  }, [bookingId])

  if (!detail || !detail.checkInRequired) return null
  if (detail.owner && detail.owner.username === username) return null

  const guest = (detail.guest || []).find(item => item.username === username)
  if (!guest) return null

  const label = getGuestLabel(guest)
  const renderStatus = () => {
    if (guest.checkInTime) {
      return (
        <span className='guest-check-in-badge'>
          <span className='guest-check-in-badge-icon' />
          {ATTENDEE_CHECK_IN.CHECKED_IN[language]}
        </span>
      )
    }

    return <span className='guest-check-in-status'>{ATTENDEE_CHECK_IN.NOT_CHECKED_IN[language]} · {ATTENDEE_CHECK_IN.USE_PIN_AT_ROOM[language]}</span>
  }

  return (
    <GuestCheckInStatusStyled colorTheme={colorTheme} className={guest.checkInTime ? 'checked-in' : ''}>
      <span className='guest-check-in-avatar'>
        {guest.profileThumbnail
          ? <img src={`data:image/png;base64,${guest.profileThumbnail}`} alt={label} />
          : getInitials(label)}
      </span>
      <span className='guest-check-in-title'>{ATTENDEE_CHECK_IN.YOUR_CHECK_IN[language]}</span>
      {renderStatus()}
    </GuestCheckInStatusStyled>
  )
}

const mapStateToProps = ({ accountReducer }) => {
  return {
    language: accountReducer.language,
    username: accountReducer.user.username,
    colorTheme: accountReducer.user.colorThemePalette,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBookingCheckIn: (bookingId) => dispatch(BOOKING.action.getBookingCheckIn(bookingId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestCheckInStatus)
